import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Free site survey & 3D design",
    text: "Our engineers visit, measure your roof and show you a photorealistic 3D design before you pay a rupee.",
  },
  {
    n: "02",
    title: "Subsidy & net-metering approval",
    text: "We file the PM Surya Ghar application and DISCOM paperwork on your behalf. Up to ₹78,000 back.",
  },
  {
    n: "03",
    title: "1-day professional installation",
    text: "Certified crews, German-grade structures, same-day commissioning for most residential systems.",
  },
  {
    n: "04",
    title: "25-year monitoring & care",
    text: "AI monitoring app, preventive maintenance visits and rapid response support for the life of the plant.",
  },
];

export const Process = () => (
  <section id="process" className="relative border-y border-white/5 bg-ink py-24 lg:py-32">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-2xl"
      >
        <p className="eyebrow">05 — How it works</p>
        <h2 className="mt-4 font-display text-3xl sm:text-5xl font-bold tracking-tight leading-[1.08]">
          Sunlight to switchboard <span className="text-gold-grad">in four steps.</span>
        </h2>
      </motion.div>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="process-steps">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="group relative rounded-2xl border border-white/10 bg-surface p-7 transition-colors duration-300 hover:border-gold/35"
            data-testid={`process-step-${s.n}`}
          >
            <p className="font-display text-5xl font-extrabold text-gold/20 transition-colors duration-300 group-hover:text-gold/50">
              {s.n}
            </p>
            <h3 className="mt-5 font-display text-lg font-bold leading-snug text-warm">{s.title}</h3>
            <p className="mt-3 text-[13px] leading-relaxed text-mutegray">{s.text}</p>
            {i < STEPS.length - 1 && (
              <span
                aria-hidden="true"
                className="absolute top-10 -right-3 hidden h-px w-6 bg-gradient-to-r from-gold/60 to-transparent lg:block"
              />
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
